<template>
	<div class="stockByCustomer">
		<div class="content-view">
			<component :is="nodeInfo" :auth="nodeAuth"></component>
		</div>
	</div>
</template>

<script>
	import StockByCustomer from './StockByCustomer/StockByCustomer.vue';
	export default {
		data() {
			return {
				nodeInfo: StockByCustomer,
				nodeAuth: null,
			}
		},
		computed: {
			menusData() {
				return this.$store.state.MenusData.Menus;
			}
		},
		created() {
			this.setMenuList();
		},
		methods: {
			setMenuList() {
				let NodeInfo = this.menusData.filter(item => item.NodeID === '18')[0].Nodes.filter(item => item.NodeID ===
					'171')[0];
				this.nodeAuth = NodeInfo.Nodes && NodeInfo.Nodes.map(item => item.NodeName);
			}
		}
	}
</script>

<style scoped lang="less">
	.stockByCustomer {
		padding: 24px;
		min-height: 80vh;
		position: relative;
		background: #ffffff;

		.content-view {
			margin-top: 16px;
		}
	}
</style>